var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "at-symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-at-symbol"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0a12.5,12.5,0,0,0,0,25,1,1,0,0,0,0-2A10.5,10.5,0,1,1,23,12.5v3a2.5,2.5,0,0,1-5,0v-3a5.5147,5.5147,0,1,0-1.8469,4.1035A4.4912,4.4912,0,0,0,25,15.5v-3A12.5141,12.5141,0,0,0,12.5,0Zm0,16A3.5,3.5,0,1,1,16,12.5,3.5039,3.5039,0,0,1,12.5,16Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSymbol);
export default __webpack_public_path__ + "static/media/at-symbol.385a4c3c48998451a75a19c7a3a41013.svg";
export { ForwardRef as ReactComponent };